<template>
  <asc-subtitle :value="value" uppercase></asc-subtitle>
</template>

<script>
import AscSubtitle from './AscSubtitle'

export default {
  name: 'AscDialogSubtitle',

  components: {
    AscSubtitle,
  },

  props: {
    value: {
      type: String,
      required: true,
    },
  },
}
</script>

<style>
.asc-dialog-subtitle .asc-header--h3 {
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 1px;
  line-height: 18px;
  word-break: normal;
}
</style>
